import React from 'react';
export function PainPointsSection() {
  return <section className="py-10 sm:py-20 bg-white relative overflow-hidden" data-id="element-114">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-115">
        {/* Headline */}
        <div className="text-center mb-8 sm:mb-12" data-id="element-116">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-[#0a1628] uppercase italic leading-tight tracking-tight" data-id="element-117">
            SI SOS DOCENTE DE PROYECTO ORGANIZACIONAL,{' '}
            <br className="hidden sm:block" data-id="element-118" />
            <span className="bg-[#fbbf24] text-white px-3 py-1 sm:py-2 rounded-lg inline-block mt-2 transform -rotate-1 shadow-sm" data-id="element-119">
              ESTO TE VA A SONAR FAMILIAR...
            </span>
          </h2>
        </div>

        {/* Pain Points */}
        <div className="flex flex-col gap-3 sm:gap-4 mb-10 sm:mb-12" data-id="element-120">
          {/* Card 1 */}
          <div className="bg-white rounded-xl shadow-[0_2px_15px_rgba(0,0,0,0.04)] border border-gray-100 p-4 sm:p-5 flex items-start gap-3 sm:gap-4 relative overflow-hidden" data-id="element-121">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-green-500" data-id="element-122"></div>
            <span className="text-2xl sm:text-3xl flex-shrink-0" data-id="element-123">📋</span>
            <p className="text-gray-700 text-sm sm:text-lg leading-relaxed" data-id="element-124">
              <strong className="text-gray-900" data-id="element-125">Armás clases desde cero</strong>{' '}
              una y otra vez, perdiendo horas valiosas de tu tiempo personal.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-xl shadow-[0_2px_15px_rgba(0,0,0,0.04)] border border-gray-100 p-4 sm:p-5 flex items-start gap-3 sm:gap-4 relative overflow-hidden" data-id="element-126">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-yellow-400" data-id="element-127"></div>
            <span className="text-2xl sm:text-3xl flex-shrink-0" data-id="element-128">😰</span>
            <p className="text-gray-700 text-sm sm:text-lg leading-relaxed" data-id="element-129">
              Terminás una clase y{' '}
              <strong className="text-gray-900" data-id="element-130">
                ya estás pensando en la siguiente
              </strong>
              , sin descanso mental real.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-xl shadow-[0_2px_15px_rgba(0,0,0,0.04)] border border-gray-100 p-4 sm:p-5 flex items-start gap-3 sm:gap-4 relative overflow-hidden" data-id="element-131">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-orange-500" data-id="element-132"></div>
            <span className="text-2xl sm:text-3xl flex-shrink-0" data-id="element-133">😤</span>
            <p className="text-gray-700 text-sm sm:text-lg leading-relaxed" data-id="element-134">
              Trabajás mucho, pero sentís que{' '}
              <strong className="text-gray-900" data-id="element-135">nunca alcanza</strong> y el
              material se agota rápido.
            </p>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-xl shadow-[0_2px_15px_rgba(0,0,0,0.04)] border border-gray-100 p-4 sm:p-5 flex items-start gap-3 sm:gap-4 relative overflow-hidden" data-id="element-136">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-red-500" data-id="element-137"></div>
            <span className="text-2xl sm:text-3xl flex-shrink-0" data-id="element-138">😓</span>
            <p className="text-gray-700 text-sm sm:text-lg leading-relaxed" data-id="element-139">
              Entrás al aula{' '}
              <strong className="text-gray-900" data-id="element-140">
                cansado/a antes de empezar
              </strong>{' '}
              por el estrés de la planificación.
            </p>
          </div>
        </div>

        {/* Motivational Message */}
        <div className="text-center space-y-3 mb-10 sm:mb-14" data-id="element-141">
          <p className="text-lg sm:text-2xl font-bold text-indigo-900/80 flex items-center justify-center flex-wrap gap-2" data-id="element-142">
            <span data-id="element-143">❌ No es falta de vocación.</span>{' '}
            <span data-id="element-144">❌ No es falta de ganas.</span>
          </p>
          <p className="text-xl sm:text-3xl font-black text-[#0a1628]" data-id="element-145">
            👉 Es falta de un sistema claro y material listo.
          </p>
        </div>

        {/* Solution Header */}
        <div className="text-center mb-6 sm:mb-8" data-id="element-146">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-black text-blue-800 uppercase mb-2 sm:mb-3 tracking-tight" data-id="element-147">
            Por eso creamos el KIT COMPLETO
            <br className="hidden sm:block" data-id="element-148" /> PROYECTO ORGANIZACIONAL LISTA
          </h3>
          <p className="text-gray-600 text-sm sm:text-lg max-w-xl mx-auto font-medium" data-id="element-149">
            Un sistema pensado para dejar de improvisar y entrar al aula con
            todo resuelto.
          </p>
        </div>

        {/* Benefit Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-8 sm:mb-10" data-id="element-150">
          {/* Benefit 1 */}
          <div className="bg-blue-50/70 rounded-xl border border-blue-100 p-4 sm:p-5 flex items-start gap-3 relative overflow-hidden" data-id="element-151">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-blue-500" data-id="element-152"></div>
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-153">📚</span>
            <div data-id="element-154">
              <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base" data-id="element-155">
                Todos los años organizados
              </h4>
              <p className="text-gray-600 text-xs sm:text-sm" data-id="element-156">
                6 módulos completos, estructurados pedagógicamente.
              </p>
            </div>
          </div>

          {/* Benefit 2 */}
          <div className="bg-green-50/70 rounded-xl border border-green-100 p-4 sm:p-5 flex items-start gap-3 relative overflow-hidden" data-id="element-157">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-green-500" data-id="element-158"></div>
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-159">✅</span>
            <div data-id="element-160">
              <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base" data-id="element-161">
                Clases listas para aplicar
              </h4>
              <p className="text-gray-600 text-xs sm:text-sm" data-id="element-162">
                Actividades probadas en el aula, sin empezar de cero.
              </p>
            </div>
          </div>

          {/* Benefit 3 */}
          <div className="bg-purple-50/70 rounded-xl border border-purple-100 p-4 sm:p-5 flex items-start gap-3 relative overflow-hidden" data-id="element-163">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-purple-500" data-id="element-164"></div>
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-165">📖</span>
            <div data-id="element-166">
              <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base" data-id="element-167">
                Contenidos claros y prácticos
              </h4>
              <p className="text-gray-600 text-xs sm:text-sm" data-id="element-168">
                Teoría paso a paso, ejemplos reales y recursos visuales.
              </p>
            </div>
          </div>

          {/* Benefit 4 */}
          <div className="bg-amber-50/70 rounded-xl border border-amber-100 p-4 sm:p-5 flex items-start gap-3 relative overflow-hidden" data-id="element-169">
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-amber-500" data-id="element-170"></div>
            <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-171">🧘</span>
            <div data-id="element-172">
              <h4 className="font-bold text-gray-900 mb-1 text-sm sm:text-base" data-id="element-173">
                Más tiempo y tranquilidad
              </h4>
              <p className="text-gray-600 text-xs sm:text-sm" data-id="element-174">
                Menos planificación. Más seguridad. Recuperá tus fines de
                semana.
              </p>
            </div>
          </div>
        </div>

        {/* Closing Line */}
        <div className="text-center" data-id="element-175">
          <p className="inline-block font-bold text-[#16a34a] text-sm sm:text-lg bg-green-50 px-4 sm:px-6 py-2 sm:py-3 rounded-full border border-green-100 shadow-sm" data-id="element-176">
            ✨ Menos estrés. Más orden. Más disfrute al dar clase.
          </p>
        </div>
      </div>
    </section>;
}